import axiosInstance from './axiosInstance.service';
import {
  IIndividualScreeningSearchParams,
  IDigitalWalletScreeningSearchParams,
  IJobsFilters,
  IAlertsFilters,
  IScreeningResultsFilters,
} from 'src/types';

/**
 * Screen the given business
 * @param searchParams
 * @param filters
 * @param page
 * @param recordsPerPage
 * @param sortBy
 * @param jobEntityId
 */
// @ts-ignore
export const screenBusiness = (
  searchParams: any,
  filters: any,
  page: any,
  recordsPerPage: any,
  sortBy: any,
  jobEntityId: string,
) => {
  return axiosInstance.get('screen/business', {
    params: {
      ...searchParams,
      country: typeof searchParams.country === 'object' ? JSON.stringify(searchParams.country) : searchParams.country,
      ...filters,
      page,
      recordsPerPage,
      sortBy,
      jobEntityId,
    },
  });
};

/**
 * Screen the given individual
 * @param searchParams
 * @param filters
 * @param page
 * @param recordsPerPage
 * @param sortBy
 * @param jobEntityId
 */
export const screenIndividual = (
  searchParams: IIndividualScreeningSearchParams,
  filters: IScreeningResultsFilters,
  page: string,
  recordsPerPage: number,
  sortBy: string,
  jobEntityId: string,
) => {
  return axiosInstance.get('screen/individual', {
    params: {
      ...searchParams,
      country: typeof searchParams.country === 'object' ? JSON.stringify(searchParams.country) : searchParams.country,
      ...filters,
      page,
      recordsPerPage,
      sortBy,
      jobEntityId,
    },
  });
};

/**
 * Screen the given digital wallet
 * @param searchParams
 */
export const screenDigitalWallet = (searchParams: IDigitalWalletScreeningSearchParams) => {
  return axiosInstance.get('screen/digital-wallet', {
    params: { ...searchParams },
  });
};

/**
 * Screen the given digital wallet
 * @param searchParams
 */
export const getDigitalWalletPdf = (searchParams: IDigitalWalletScreeningSearchParams) => {
  return axiosInstance('screen/digital-wallet-pdf', {
    method: 'POST',
    responseType: 'arraybuffer',
    data: {
      identifier: searchParams.identifier,
      blockchain: searchParams.currency?.toString(),
    },
  });
};

/**
 * this function starts batch screening in the background process
 * @param formData
 * @param fileUploadProgressTracker
 */
// @ts-ignore
export const startBatchScreening = (
  formData: FormData,
  fileUploadProgressTracker: (progress: number) => void,
) => {
  return axiosInstance.post('screen/batch', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress: (data) => {
      fileUploadProgressTracker(Math.round((100 * data.loaded) / (data.total || 0)));
    },
  });
};

// @ts-ignore
export const fetchJobs = (
  filters: IJobsFilters,
  page: string,
  recordsPerPage: number,
  sortBy: string,
) => {
  return axiosInstance.get('jobs', {
    params: {
      ...filters,
      page,
      recordsPerPage,
      sortBy,
    },
  });
};

export const fetchAlerts = (
  filters: IAlertsFilters,
  page: string,
  recordsPerPage: number,
  sortBy: string,
) => {
  return axiosInstance.get('alerts', {
    params: {
      ...filters,
      page,
      recordsPerPage,
      sortBy,
    },
  });
};

export const fetchAlertsByJobIds = (jobIds: string[]) => {
  return axiosInstance.post('alerts/job', {
    params: {},
    data: { jobIds },
  });
};

/**
 * This function get the job entities already screened via backend service
 * @param jobId
 * @param filters
 * @param page
 * @param recordsPerPage
 */
// @ts-ignore
export const getJobEntities = (jobId, filters, page, recordsPerPage) => {
  return axiosInstance.get(`jobs/${jobId}`, {
    params: {
      ...filters,
      page,
      recordsPerPage,
    },
  });
};

/**
 * This function get already screened matches from backend.
 * @param jobId
 * @param entityId
 * @param filters
 * @param page
 * @param recordsPerPage
 * @param sortBy
 */
// @ts-ignore
export const getScreenedJobMatches = (jobId, entityId, filters, page, recordsPerPage, sortBy) => {
  return axiosInstance.get(`jobs/${jobId}/matches/${entityId}`, {
    params: {
      ...filters,
      page,
      recordsPerPage,
      sortBy,
    },
  });
};

export const downloadCsv = (jobEntityId: string) => {
  return axiosInstance.get(`export/csv/?entityId=${jobEntityId}`);
};
